import { memo } from 'react';
import { mentionMenu } from './MDTextarea.css';

type Props = {
  top: number;
  left: number;
  onSelect: () => void;
};

export const MDMentionMenu = memo(({ top, left, onSelect }: Props) => (
  <div
    className={mentionMenu.wrapper}
    style={{ top, left }}
    role="listbox"
    aria-label="mention options"
  >
    <button
      className={mentionMenu.optionButton}
      onClick={onSelect}
      type="button"
    >
      <span className={mentionMenu.optionTitle}>@community</span>
      <span className={mentionMenu.optionSubtitle}>
        Notify everyone in the community
      </span>
    </button>
  </div>
));

MDMentionMenu.displayName = 'MDMentionMenu';
